import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { ClickOutsideDirective } from './directives/click-outside.directive'
import { FeatureFlagDirective } from './directives/feature-flag.directive'
import { PersonLinkDirective } from './directives/person-link.directive'
import { ArticleForNamePipe } from './pipes/article-for-name.pipe'

@NgModule({
  imports: [
    CommonModule,
    ArticleForNamePipe,
    PersonLinkDirective,
    ClickOutsideDirective,
    FeatureFlagDirective,
  ],
  exports: [
    PersonLinkDirective,
    ClickOutsideDirective,
    ArticleForNamePipe,
    FeatureFlagDirective,
  ],
})
export class SharedModule {}
